module.exports = __webpack_public_path__ + "img/Frame-left2.6d81bb56.png";